import {getField, updateField} from 'vuex-map-fields';
import Customer from '@/commonFunction/baseTableModule'

let customer = new Customer('/ws/table/variant/');

const state = {
    ...customer.state,
};
const getters = {
    ...customer.getters,
};
const actions = {
    ...customer.actions,
};
const mutations = {
    ...customer.mutations,
};

export default {
    modules: {
        Variant: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}
